import { createContext, useCallback, useContext, useState } from 'react';
import { useAuthenticatedApiContext } from '../api/useApiClient';
import { TaniumInstance } from '../types';
import { AsyncState, useAsync } from './useAsync';
import { useAsyncEffect } from './useAsyncEffect';

interface TaniumInstancesCtx {
  linkedTaniumInstances: TaniumInstance[];
  loadLinkedTaniumInstances: AsyncState<void, () => Promise<void>>;
}

const TaniumInstancesContext = createContext<TaniumInstancesCtx>({} as TaniumInstancesCtx);

export const TaniumInstancesProvider: React.FC = ({ children }) => {
  const taniumInstancesHook = useTaniumInstancesHook();
  return (
    <TaniumInstancesContext.Provider value={{ ...taniumInstancesHook }}>{children}</TaniumInstancesContext.Provider>
  );
};

export function useTaniumInstances(): TaniumInstancesCtx {
  return useContext(TaniumInstancesContext);
}

const useTaniumInstancesHook = () => {
  const [linkedTaniumInstances, setLinkedTaniumInstances] = useState<TaniumInstance[]>([]);
  const apiClient = useAuthenticatedApiContext();

  const loadLinkedTaniumInstances = useAsync(
    useCallback((): Promise<void> => {
      return apiClient.getLinkedInstances().then((res) => setLinkedTaniumInstances(res));
    }, [apiClient]),
    { autoReset: true }
  );
  useAsyncEffect(loadLinkedTaniumInstances, []);

  return { loadLinkedTaniumInstances, linkedTaniumInstances };
};
